import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "navbar shadow-sm px-5 p-0 bg-white rounded" }
const _hoisted_2 = { class: "col-sm-1" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 0,
  class: "navbar-menu h-100 col-7 float-start d-flex justify-content-center align-items-center mb-0 p-0"
}
const _hoisted_5 = ["data-cy", "onClick"]
const _hoisted_6 = { class: "navbar-subitems" }
const _hoisted_7 = ["data-cy", "onClick"]
const _hoisted_8 = { class: "material-symbols-outlined me-1" }
const _hoisted_9 = { class: "mb-0" }
const _hoisted_10 = {
  key: 1,
  class: "navbar-menu h-100 col-9 float-start d-flex justify-content-center align-items-center mb-0 p-0"
}
const _hoisted_11 = ["data-cy", "onClick"]
const _hoisted_12 = { class: "profile-options col-md-2" }
const _hoisted_13 = { class: "dropdown" }
const _hoisted_14 = {
  class: "float-start dropdown-menu",
  "aria-labelledby": "dropdownMenuButton1"
}
const _hoisted_15 = { class: "cursor-pointer" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined me-1" }, " settings ", -1)
const _hoisted_17 = {
  key: 0,
  class: "cursor-pointer"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined me-1" }, " payments ", -1)
const _hoisted_19 = {
  key: 1,
  class: "cursor-pointer"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined me-1" }, " sell ", -1)
const _hoisted_21 = {
  key: 2,
  class: "cursor-pointer"
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined me-1" }, " corporate_fare ", -1)
const _hoisted_23 = { class: "cursor-pointer" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", { class: "material-symbols-outlined me-1" }, " logout ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ds_button = _resolveComponent("ds-button")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        class: "ms-3 navbar-brand float-start",
        src: require('@/assets/images/logo_iosi_blue.png'),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.redirect && _ctx.redirect(...args)))
      }, null, 8, _hoisted_3)
    ]),
    (_ctx.roles == 'ADMIN' || _ctx.roles == 'ADMIN_IOSI')
      ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checkRoles(), (menu) => {
            return (_openBlock(), _createElementBlock("li", {
              key: menu.link,
              "data-cy": menu.link,
              class: _normalizeClass(["navbar-item h-100 p-3 d-flex justify-content-center align-items-center", {'active': _ctx.isActive(menu.link)}]),
              onClick: ($event: any) => (_ctx.goTo(menu.link))
            }, _toDisplayString(_ctx.$t( menu.title_key)), 11, _hoisted_5))
          }), 128)),
          _createElementVNode("li", {
            class: _normalizeClass(["navbar-item schedule-item h-100 p-3 mx-3 d-flex justify-content-center align-items-center", {'active': _ctx.isActive('/schedule') || _ctx.isActive('/groups')}])
          }, [
            _createTextVNode(_toDisplayString(_ctx.$t('menu.schedule')) + " ", 1),
            _createElementVNode("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scheduleItems, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.link,
                  "data-cy": item.link,
                  class: "navbar-subitem py-3 px-5 d-flex justify-content-center align-items-center",
                  onClick: ($event: any) => (_ctx.goTo(item.link))
                }, [
                  _createElementVNode("span", _hoisted_8, _toDisplayString(item.icon), 1),
                  _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.$t(item.title_key)), 1)
                ], 8, _hoisted_7))
              }), 128))
            ])
          ], 2)
        ]))
      : (_openBlock(), _createElementBlock("ul", _hoisted_10, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.clientMenu, (menu) => {
            return (_openBlock(), _createElementBlock("li", {
              key: menu.link,
              "data-cy": menu.link,
              class: _normalizeClass(["navbar-item client-item h-100 p-3 mx-3 d-flex justify-content-center align-items-center", {'active': _ctx.isActive(menu.link)}]),
              onClick: ($event: any) => (_ctx.goTo(menu.link))
            }, _toDisplayString(_ctx.$t(menu.title_key)), 11, _hoisted_11))
          }), 128))
        ])),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_ds_button, {
          text: _ctx.userInfo.name,
          class: "dropdown-toggle d-flex align-items-center",
          type: "tertiary",
          action: "button",
          id: "dropdownMenuButton1",
          "data-bs-toggle": "dropdown",
          "aria-expanded": "false"
        }, null, 8, ["text"]),
        _createElementVNode("ul", _hoisted_14, [
          _createElementVNode("li", _hoisted_15, [
            _createElementVNode("a", {
              class: "dropdown-item",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goTo('/profile')))
            }, [
              _hoisted_16,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('profile.title')), 1)
            ])
          ]),
          (_ctx.roles == 'CLIENT' || _ctx.roles == 'USER')
            ? (_openBlock(), _createElementBlock("li", _hoisted_17, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goTo('/historico-pagamentos')))
                }, [
                  _hoisted_18,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('financial.history')), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.roles == 'ADMIN_IOSI')
            ? (_openBlock(), _createElementBlock("li", _hoisted_19, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goTo('/coupons')))
                }, [
                  _hoisted_20,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('coupons.title')), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.roles == 'ADMIN')
            ? (_openBlock(), _createElementBlock("li", _hoisted_21, [
                _createElementVNode("a", {
                  class: "dropdown-item",
                  onClick: _cache[4] || (_cache[4] = () => _ctx.$router.push({name: 'editOrganization', params: { id: _ctx.userOrgId }}))
                }, [
                  _hoisted_22,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t('menu.orgAdm')), 1)
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("li", _hoisted_23, [
            _createElementVNode("a", {
              class: "dropdown-item logout-item",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.logout()))
            }, [
              _hoisted_24,
              _createTextVNode(" " + _toDisplayString(_ctx.$t('menu.logout')), 1)
            ])
          ])
        ])
      ])
    ])
  ]))
}